import React from "react";

const inputModeByType = {
  email: "email",
  number: "decimal",
  tel: "tel",
  search: "search",
  url: "url",
};

const autoCompleteByType = {
  email: "email",
  tel: "tel",
  url: "url",
  search: "off",
  password: "current-password",
};

function applyDefaults(root = document) {
  root.querySelectorAll("input:not([type='hidden']), textarea").forEach((field) => {
    const type = field.getAttribute("type") || "text";
    if (!field.hasAttribute("inputmode")) field.setAttribute("inputmode", inputModeByType[type] || "text");
    if (!field.hasAttribute("autocomplete")) field.setAttribute("autocomplete", autoCompleteByType[type] || field.getAttribute("name") || "off");
    if (!field.hasAttribute("enterkeyhint")) field.setAttribute("enterkeyhint", type === "search" ? "search" : "next");
    field.setAttribute("data-ptr-ignore", "true");
    if (!field.getAttribute("aria-label") && !field.id && field.getAttribute("placeholder")) field.setAttribute("aria-label", field.getAttribute("placeholder"));
  });

  root.querySelectorAll("select").forEach((field) => {
    field.setAttribute("data-ptr-ignore", "true");
    if (!field.hasAttribute("autocomplete")) field.setAttribute("autocomplete", field.getAttribute("name") || "off");
    if (!field.getAttribute("aria-label") && field.getAttribute("name")) field.setAttribute("aria-label", field.getAttribute("name").replace(/[-_]/g, " "));
  });
}

export default function FormAttributeDefaults() {
  React.useEffect(() => {
    applyDefaults();
    const observer = new MutationObserver(() => applyDefaults());
    observer.observe(document.body, { childList: true, subtree: true });
    return () => observer.disconnect();
  }, []);

  return null;
}